<template>
  <div class="reports">
    <br>
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="learnerReport"
      class="layout"
    >
      <br>
      <form @submit.prevent="handleSubmit">
        <div class="head">
          <img class="logo" src="@/assets/logo.svg" alt="logo">
          <h4>Inspire Leadership Report Card</h4>
        </div>
        <div class="learner-info">
        <label>{{ learnerReport.displayName }}</label>
        <label>{{ learnerReport.grade }}</label>
        </div>

        <div class="work-items">
        <table class="item-list">
            <tr class="table-heading flex">
            <th class="subject-name">Subject</th>
            <th class="mark">Marks(%)</th>
            <th class="comment">Comment</th>
            </tr>
            <tr class="table-items flex" v-for="(subject, index) in learnerReport.subjectList" :key="index">
            <td class="subject-name"><input type="text" v-model="subject.subjectName" disabled/></td>
            <td class="mark"><input type="number" min="0" max="100" v-model="subject.mark" disabled/></td>
            <td class="comment"><input type="text" v-model="subject.comment" disabled/></td>
            </tr>
        </table>
        </div>
      </form>
    </div>
    <div
      v-else
      class="card"
    >
      <p>No performance report at the moment, check back later</p>
      <Spinner />
    </div>
  </div>
</template>

<script>
import getPosts from '@/composables/getPosts'
import Spinner from '@/components/Spinner.vue'
import { ref, watchEffect } from '@vue/runtime-core'

export default {
  name: 'Report Card',
  props: ['classLearner'],
  components: { Spinner },
  setup (props, context) {
    const filteredReports = ref(null)
    const learnerReport = ref(null)
    const { myData, error, load } = getPosts()

    load(props.classLearner.grade + '/reports/teacher')

    watchEffect(() => {
      filteredReports.value =
        myData.value ? myData.value.filter(learnerReport => learnerReport.displayName === props.classLearner.user.displayName)
          : null
      learnerReport.value = filteredReports.value[0]
    })

    return { learnerReport, error }
  }
}
</script>

<style>
    .reports .layout form {
      max-width: 800px;
    }
    .reports .learner-info {
      display: flex;
      justify-content: space-around;
    }
    .reports .layout .head {
      display: flex;
      justify-content: space-between;
      align-content: center;
    }
    .reports .layout .logo {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .reports .work-items .item-list {
      width: 100%;
    }
    .table-heading,.table-items {
      gap: 16px;
      font-size: 12px;
    }
    .subject-name {
      flex-basis: 37%;
    }
    .mark {
      flex-basis: 18%;
    }
    .comment {
      flex-basis: 45%;
    }
    .table-heading {
      margin-bottom: 16px;
    }
    th {
      text-align: left;
    }
    .table-items {
      position: relative;
      margin-bottom: 24px;
    }
</style>
